import News from "./components/News";
import React from "react";
function App() {
  return (
    <>
      <News />
    </>
  );
}
export default App;
